import {
  gsap
} from "gsap/dist/gsap";
import {
  ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
  ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
  paused: false, // default is false
  smoothChildTiming: true,
});
headerBarAnimate
  .fromTo(
    headerBar, {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 0.5,
    },
    "<.2")
  .fromTo(headerBar, {
    scale: 0.95
  }, {
    scale: 1,
    duration: 1
  }, "<.1");


let timelinePortofolio = gsap.timeline({
  paused: true, // default is false
  defaults: { // children inherit these defaults
    duration: 1.5,
    ease: "power2.out"
  },
  smoothChildTiming: true,
});
timelinePortofolio
.fromTo('.top-page-ornament',{
  opacity:0,
  scale:0.6
},{
  opacity:1,
  scale:1,
},'<.1')
.fromTo('.titlePortofolio', {
  opacity: 0,
  scale: 0.6,

}, {
  opacity: 1,
  scale: 1,
  delay: .1,
  stagger: .2
}, '<.1')
document.addEventListener("DOMContentLoaded", function () {
  if (preLoaderEl) {
    setTimeout(function () {
      preLoaderEl.classList.add('hide');
      mainContent.classList.remove('overflow-hidden');
      mainContent.classList.remove('opacity-0');
      mainContent.classList.add('opacity-100');
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 1300);
  }

  setTimeout(function () {
    headerBarAnimate.play();
    timelinePortofolio.play();

    const portofolio = document.querySelectorAll('.our-work__portofolio');
    portofolio.forEach((portofolioItem, index) => {
      const cardAnimate = gsap.timeline({
        paused: true, // Atur menjadi true agar animasi tidak dijalankan secara otomatis
        defaults: {
          duration: 1,
          ease: "power2.out"
        },
      });

      const cardImage = portofolioItem.querySelector('.image-zoom');

      cardAnimate.fromTo(portofolioItem.children[0], {
        width: '75%',
        duration: 1,

    }, {
        width: '100%',
        stagger: .2
    }, '<.1')
    .fromTo(portofolioItem.children[0].children[0], {
        scale: 1.2
    }, {
        duration: 1,
        scale: 1,
        stagger: .2
    }, '-=1');



      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            cardAnimate.play(); 
            observer.unobserve(entry.target); 
          }
        });
      });

      observer.observe(portofolioItem);
    });
  }, 1300)
})


// const leftImages = document.querySelectorAll('.leftImage');
// const rightImages = document.querySelectorAll('.rightImage');

// // Function to handle scroll event
// function leftHandleScroll() {
//   leftImages.forEach(image => {
//     const rect = image.getBoundingClientRect();
//     const translateY = window.scrollY - rect.top;

//     // Apply the transform based on scroll direction
//     gsap.to(image, {
//       x: translateY > 0 ? -translateY / 10 : 0, // Adjust the division value to control the amount of movement
//       ease: 'none'
//     });
//   });
// }

// // Attach the scroll event listener
// window.addEventListener('scroll', leftHandleScroll);


// function rightHandleScroll() {
//   rightImages.forEach(image => {
//     const rect = image.getBoundingClientRect();
//     const translateY = window.scrollY - rect.top;

//     // Apply the transform based on scroll direction
//     gsap.to(image, {
//       x: translateY > 0 ? translateY / 10 : 0, // Adjust the division value to control the amount of movement
//       ease: 'none'
//     });
//   });
// }

// // Attach the scroll event listener
// window.addEventListener('scroll', rightHandleScroll);